var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"loading":_vm.loading}},[_c('div',{attrs:{"id":"video-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }